
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qmee/cashbacks",
      function () {
        return require("private-next-pages/qmee/cashbacks.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qmee/cashbacks"])
      });
    }
  